// Position configuration (shared between languages)
const positionConfig_9P = {
    image: {
        top: '120px',
        left: '200px',
        width: '400px'
    }
};

export const scoring_level_eng_9P = {
    // Display configuration for English version
    displayConfig: {
        pageToShow: 13,
        position: {
            ...positionConfig_9P,
            description: {
                top: '340px',
                fontSize: '17px',
                fontWeight: 700,
                width: '80%',
                maxWidth: '600px',
                textAlign: 'center',
                display: 'block',
                position: 'relative',
                margin: '0 auto'
            },
            description_2: {
                top: '365px',
                fontSize: '17px',
                fontWeight: 700,
                width: '80%',
                maxWidth: '600px',
                textAlign: 'center',
                display: 'block',
                position: 'relative',
                margin: '0 auto'
            }
        }
    },
    
    // Scoring levels
    levels: [
        {
            min: 0,
            max: 3,
            img: 'level_1',
            color: '#8bcc2c',
            description: 'Your test results show a <span style="color: #8bcc2c; font-weight: bold;">Considerably Balanced</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.'
        },
        {
            min: 4,
            max: 6,
            img: 'level_2',
            color: '#fa891f',
            description: 'Your test results show a <span style="color: #ccc72c; font-weight: bold;">Mild Dysbiosis</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.'
        },
        {
            min: 7,
            max: 12,
            img: 'level_3',
            color: '#f97316',
            description: 'Your test results show a <span style="color: #cc832c; font-weight: bold;">Moderate Dysbiosis</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.'
        },
        {
            min: 13,
            max: 100,
            img: 'level_4',
            color: '#fa1f1f',
            description: 'Your test results show a <span style="color: #cc2c2c; font-weight: bold;">Significant Dysbiosis</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.'
        }
    ]
};

export const scoring_level_thai_9P = {
    // Display configuration for Thai version
    displayConfig: {
        pageToShow: 12,
        position: {
            ...positionConfig_9P,
            description: {
                top: '340px',
                fontSize: '17px',
                fontWeight: 700,
                width: '80%',
                maxWidth: '600px',
                textAlign: 'center',
                display: 'block',
                position: 'relative',
                margin: '0 auto'
            },
            description_2: {
                top: '365px',
                fontSize: '17px',
                fontWeight: 700,
                width: '80%',
                maxWidth: '600px',
                textAlign: 'center',
                display: 'block',
                position: 'relative',
                margin: '0 auto'
            }
        }
    },
    
    // Scoring levels
    levels: [
        {
            min: 0,
            max: 3,
            img: 'level_1',
            color: '#8bcc2c',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #8bcc2c; font-weight: bold;">สมดุล</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ'
        },
        {
            min: 4,
            max: 6,
            img: 'level_2',
            color: '#fa891f',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #ccc72c; font-weight: bold;">เสียสมดุลเล็กน้อย</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ'
        },
        {
            min: 7,
            max: 12,
            img: 'level_3',
            color: '#f97316',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #cc832c; font-weight: bold;">เสียสมดุลปานกลาง</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ'
        },
        {
            min: 13,
            max: 100,
            img: 'level_4',
            color: '#fa1f1f',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #cc2c2c; font-weight: bold;">เสียสมดุลรุนแรง</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ'
        }
    ]
};

// Function to calculate the overall score based on CT value results
// Updated to use the same calculation method as QU/QPT format
export const calculateOverallScore = (formData, bacteriaMetaConfig) => {
    let score = 0;
    
    // Count each type of result
    let slightlyExcessiveCount = 0;
    let slightlyDeficientCount = 0;
    let excessiveCount = 0;
    let deficientCount = 0;
    
    // Iterate through all bacteria in the config
    Object.keys(bacteriaMetaConfig).forEach(bacteriaName => {
        const bacteriaConfig = bacteriaMetaConfig[bacteriaName];
        const ctValue = formData[bacteriaName];
        
        if (ctValue !== undefined && ctValue !== null) {
            // Find the matching range for this bacteria
            const matchingRange = bacteriaConfig.rangeMapping.find(range => 
                range.condition(ctValue, formData)
            );
            
            if (matchingRange) {
                const label = matchingRange.label;
                
                // Count based on the label
                switch (label) {
                    case 'Slightly Excessive':
                        slightlyExcessiveCount++;
                        break;
                    case 'Slightly Deficient':
                        slightlyDeficientCount++;
                        break;
                    case 'Excessive':
                        excessiveCount++;
                        break;
                    case 'Deficient':
                        deficientCount++;
                        break;
                    default:
                        // Normal or other labels don't contribute to the score
                        break;
                }
            }
        }
    });
    
    // Apply the formula (same as QU/QPT format)
    score = 0.5 * slightlyExcessiveCount + 0.5 * slightlyDeficientCount + excessiveCount + deficientCount;
    
    return Math.round(score); // Round to nearest integer
};

// Function to get the appropriate scoring level based on the calculated score
export const getScoringLevel = (score, useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai_9P : scoring_level_eng_9P;
    
    return config.levels.find(level => score >= level.min && score <= level.max) || config.levels[config.levels.length - 1];
};

// Function to check if scoring level should be shown on a specific page
export const shouldShowScoringLevel = (pageNumber, totalPages, useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai_9P : scoring_level_eng_9P;
    const { pageToShow } = config.displayConfig;
    
    if (typeof pageToShow === 'number') {
        return pageNumber === pageToShow;
    }
    
    if (pageToShow === 'first') {
        return pageNumber === 1;
    }
    
    if (pageToShow === 'last') {
        return pageNumber === totalPages;
    }
    
    if (pageToShow === 'all') {
        return true;
    }
    
    if (Array.isArray(pageToShow)) {
        return pageToShow.includes(pageNumber);
    }
    
    // Default to page 1 if invalid configuration
    return pageNumber === 1;
};

// Function to get display configuration for a specific language
export const getScoringDisplayConfig = (useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai_9P : scoring_level_eng_9P;
    return config.displayConfig;
};